import React from "react";
import { Text, View } from "react-native";
import { STYLES } from "../assets/styles";
import CustomIcon from "./CustomIcon";

function Price({
  price,
  discount,
  mrp,
  style = {},
  size = STYLES.fontSizes.large,
}) {
  return (
    <View style={style}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <CustomIcon
          type="Fontisto"
          name="shopping-bag-1"
          style={{
            color: "black",
            fontSize: size * 0.9,
            padding: 2,
            paddingRight: 4,
            opacity: 0.5,
          }}
        />
        <Text
          style={{
            fontWeight: "bold",
            fontSize: size * 1.1,
            color: "black",
          }}
        >
          {price}
        </Text>
      </View>
      {discount ? (
        <View
          style={{
            flexDirection: "row",
            alignItems: "flex-end",
          }}
        >
          <Text
            style={{
              fontSize: size,
              color: STYLES.colors.black,
              textDecorationLine: "line-through",
              marginHorizontal: 4,
            }}
          >
            {mrp}
          </Text>
          <Text
            style={{
              fontWeight: "bold",
              fontSize: size,
              color: STYLES.colors.purpel,
            }}
          >
            {discount} % off
          </Text>
        </View>
      ) : null}
    </View>
  );
}

export default Price;
